import dayjs from 'dayjs';
import {Guest, Location, PhoneDetails, SelectOptionType} from '@guestapp/sdk';
import {FORM_NAMES} from './constants';
import {
  isAgreementClauseField,
  isDateField,
  isPhoneField,
  isSelectField,
  isSelectOptionTypeValid,
  buildAgreementClausesFormData,
} from './utils';

const getIsEmptyPhoneValue = (value: unknown) => {
  return Object.values(value as PhoneDetails).some(val => !val);
};

const checkIsLocationValue = (value: unknown): value is Location => {
  return Boolean((value as Location)?.code && (value as Location)?.name);
};

type BuildGuestFormDataFromDBArgs = {
  guestData: Partial<Guest>;
};
const buildGuestFormDataFromDB = ({guestData}: BuildGuestFormDataFromDBArgs) => {
  if (!guestData) return;
  const guestValues = Object.entries(guestData);

  const preloadedData: {[key: string]: string | SelectOptionType | PhoneDetails | Date} =
    {};
  guestValues.forEach(([fieldName, fieldValue]: [string, unknown]) => {
    const isFieldExist = Object.values(FORM_NAMES).includes(fieldName as FORM_NAMES);

    if (!isFieldExist || !fieldValue) return;

    const isDateValue = isDateField(fieldName);
    const isLocationValue = checkIsLocationValue(fieldValue);
    const isAgreementClauseValue = isAgreementClauseField(fieldName);
    if (isAgreementClauseValue) {
      const agreementClausesFormData = buildAgreementClausesFormData(
        fieldValue as Record<string, boolean>,
      );
      preloadedData[FORM_NAMES.agreement_clauses] = agreementClausesFormData;
      return;
    }

    if (isPhoneField(fieldName)) {
      if (getIsEmptyPhoneValue(fieldValue)) return;
      preloadedData[fieldName] = fieldValue;
      return;
    }
    if (isLocationValue) {
      preloadedData[fieldName] = {
        label: fieldValue.name,
        value: fieldValue.code,
      };
      return;
    }

    if (isDateValue) {
      preloadedData[fieldName] = dayjs(fieldValue as string).toDate();
      return;
    }

    if (isSelectField(fieldName)) {
      if (!isSelectOptionTypeValid(fieldValue)) {
        return;
      }
    }
    preloadedData[fieldName] = fieldValue;
  });

  return preloadedData;
};

export {buildGuestFormDataFromDB};
